import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex flex-column pl-2 pr-2" }
const _hoisted_2 = { class: "mt-2 mb-2 flex align-items-center flex-column md:justify-content-between md:flex-row" }
const _hoisted_3 = {
  key: 0,
  class: ""
}
const _hoisted_4 = {
  key: 1,
  class: ""
}
const _hoisted_5 = { class: "flex align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimevueButton = _resolveComponent("PrimevueButton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Column = _resolveComponent("Column")!
  const _component_PrimevueTag = _resolveComponent("PrimevueTag")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (this.$route.params.typ == 1)
          ? (_openBlock(), _createElementBlock("h2", _hoisted_3, "ZOZNAM ŽIADANÝCH REZERVÁCIÍ PROFILOV"))
          : _createCommentVNode("", true),
        (this.$route.params.typ == 2)
          ? (_openBlock(), _createElementBlock("h2", _hoisted_4, "ZOZNAM ŽIADANÝCH PROFILOV NA PRESTRIEKANIE"))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          (($data.store.user.admin === true || $data.store.user.department.id == 3) && this.$route.params.typ == 1)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: "/mod-stock/reservation-requests/1/0",
                class: "mr-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_PrimevueButton, {
                    label: "Pridať žiadosť o rezerváciu",
                    severity: "success",
                    icon: "pi pi-plus",
                    text: "",
                    raised: "",
                    class: "uppercase"
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (($data.store.user.admin === true || $data.store.user.department.id == 3) && this.$route.params.typ == 2)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                to: "/mod-stock/reservation-requests/2/0",
                class: "mr-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_PrimevueButton, {
                    label: "Pridať žiadosť o prestriekanie",
                    severity: "success",
                    icon: "pi pi-plus",
                    text: "",
                    raised: "",
                    class: "uppercase"
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode(_component_DataTable, {
        class: _normalizeClass(['mobile-table', { 'compact': $data.isMobile }]),
        lazy: "",
        paginator: "",
        rows: this.pagination.rows,
        onPage: $options.onPage,
        first: this.pagination.first,
        loading: $data.loading,
        totalRecords: this.pagination.totalRecords,
        dataKey: "id",
        value: this.reservationRequests,
        filters: $data.filters,
        "onUpdate:filters": _cache[0] || (_cache[0] = ($event: any) => (($data.filters) = $event)),
        onFilter: $options.onFilter,
        filterDisplay: "row",
        globalFilterFields: $data.globalFilterFields,
        stripedRows: "",
        "row-hover": "",
        scrollable: "",
        selection: this.selectedReservationRequest,
        "onUpdate:selection": _cache[1] || (_cache[1] = ($event: any) => ((this.selectedReservationRequest) = $event)),
        selectionMode: "single",
        metaKeySelection: false,
        onRowSelect: _cache[2] || (_cache[2] = ($event: any) => ($options.showDetail(this.selectedReservationRequest.id))),
        tableStyle: "min-width: 20rem",
        virtualScrollerOptions: { itemSize: 60 },
        scrollHeight: `${this.vh - 420}px`
      }, {
        header: _withCtx(() => []),
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            header: "Objednávka",
            style: {"min-width":"6%"}
          }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(slotProps.data.order.orderCode), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            header: "Zákazník",
            style: {"min-width":"10%"}
          }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(slotProps.data.order.customerLastName) + " " + _toDisplayString(slotProps.data.order.customerFirstName), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "status",
            header: "Status",
            style: {"min-width":"4%"}
          }, {
            body: _withCtx((slotProps) => [
              _createVNode(_component_PrimevueTag, {
                class: _normalizeClass(["justify-content-center", `${this.isMobile ? 'font-normal text-xs' : 'font-medium text-base'}`]),
                value: slotProps.data.status,
                severity: slotProps.data.status == 'Nová' ? 'primary' : (slotProps.data.status == 'Rozpracovaná' ? 'warning' : 'success')
              }, null, 8, ["class", "value", "severity"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            header: "Dátum pridania",
            style: {"min-width":"4%"}
          }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString($options.Utils.parseToSlovakDate(slotProps.data.createdAt)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            header: "Dátum vybavenia",
            style: {"min-width":"4%"}
          }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(slotProps.data.executedAt != '0001-01-01T00:00:00Z' ? $options.Utils.parseToSlovakDate(slotProps.data.executedAt) : ""), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class", "rows", "onPage", "first", "loading", "totalRecords", "value", "filters", "onFilter", "globalFilterFields", "selection", "scrollHeight"])
    ]),
    _createVNode(_component_ConfirmDialog)
  ], 64))
}